










import { Component, Prop, Mixins } from "vue-property-decorator";

import { WidgetMixin, LayoutMixin } from "./mixins";

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue"),
  },
})
export default class WCard extends Mixins(WidgetMixin, LayoutMixin) {
  @Prop({ type: String, default: "" })
  borderWidth!: string;

  @Prop({ type: String, default: "" })
  borderColor!: string;

  @Prop({ type: Boolean, default: false })
  borderless!: boolean;

  @Prop({ type: Boolean, default: false })
  shadow!: boolean;

  get computedClasses() {
    return {
      shadow: this.shadow,
    };
  }

  get computedStyles() {
    return {
      // borderless prop takes precedent over borderWidth prop
      borderWidth: (this.borderless && "0") || this.borderWidth,
      borderColor: this.borderColor,
    };
  }
}
